import styled from 'styled-components'

export const StyledNoOrders = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  [`.clin-icon`]: {
    display: 'block'
  },
  [`.msg-copy`]: {
    maxWidth: '650px'
  }
})

export const StyledFlexSpacer = styled.div({
  width: '100%'
})
